import { all, takeEvery, call, put } from "redux-saga/effects";
import { remove } from "services/apis/session";
import actions from "./actions";
import { toastr } from "services/toastr";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* DELETE({ payload }) {
  const { id, filter } = payload;
  yield loading(true);

  const response = yield call(remove, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: "user/DETAIL", payload: filter });
    toastr.success("delete succeeded", "successfully deleted session!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.DELETE, DELETE)]);
}
